import { useSearchParams as useRouterSearchParams } from "react-router-dom";

function useSearchParamHandler() {
  const [searchParams, setSearchParams] = useRouterSearchParams();

  const replaceSearchParam = (paramName, paramValue, oldParams) => {
    const params = new URLSearchParams(oldParams || searchParams); // oldParams is used since Products search has memoized version which loses previous params

    if (params.has(paramName)) {
      params.set(paramName, paramValue);
    } else {
      params.append(paramName, paramValue);
    }

    return setSearchParams(params.toString());
  };

  return replaceSearchParam;
}

export default useSearchParamHandler;
